<template>
  <div class="page-amount-info">
    <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="p-0">
      <el-row>
        <div :class="{'account-info': accountInfoClass}" class="card-base card-shadow--small home-form">
          <h2 class="account-info-title" test_id="account_info_future">{{$t('tradeAccountType.'+accountInfo.tradeAccountType)}}</h2>
          <div v-if="accountInfo.tradeAccountType =='futuresMargin'" class="text-center money">
            <div class="balance yesterday-balance">
              <div class="balance-title p-10">{{$t('home.balance')}}</div>
              <div class="curBalance pb-10 ">{{accountInfo.total_balance? accountInfo.total_balance : this.this.$t('home.loadingData')}}</div>
            </div>
          </div>
          <div v-else-if="['mt5', 'mf', 'PM'].includes(accountInfo.tradeAccountType)" class="text-center money">
            <div class="balance">
              <div class="balance-title p-10">{{$t('home.accountBalance')}}</div>
              <div class="curBalance pb-10 ">{{accountInfo.total_balance? accountInfo.total_balance : this.this.$t('home.loadingData')}}</div>
            </div>
            <div>
              <div class="balance-title p-10">{{$t('home.accountInterests')}}</div>
              <div class="curBalance pb-10">{{accountInfo.fail?$t('home.'+ accountInfo.equity):accountInfo.equity}}</div>
            </div>
          </div>
          <div v-else-if="!noBalanceArr.includes(accountInfo.tradeAccountType)" class="text-center money">
            <div class="balance">
              <div class="balance-title p-10">{{$t('home.total_cash')}}</div>
              <div class="curBalance pb-10 ">{{accountInfo.total_balance? accountInfo.total_balance : this.this.$t('home.loadingData')}}</div>
            </div>
            <div>
              <div class="balance-title p-10">{{$t('home.ref_portfolio')}}</div>
              <div class="curBalance pb-10">{{accountInfo.fail?$t('home.'+ accountInfo.equity):accountInfo.equity}}</div>
            </div>
          </div>

          <el-row class="b-b1 pt-10 pb-10">
            <el-col :span="12" class="left">
              {{$t('home.currency')}}
            </el-col>
            <el-col :span="12" class="right">
              {{accountInfo.base_currency}}
            </el-col>
          </el-row>
          <!-- <el-row class="b-b1  pt-10 pb-10">
            <el-col :span="12" class="left">
              {{$t('home.type')}}
            </el-col>
            <el-col :span="12" class="right">
              {{$t('home.'+accountInfo.type)}}
            </el-col>
          </el-row> -->
          <el-row class="b-b1  pt-10 pb-10">
            <el-col :span="12" class="left">
              {{$t('home.accountNo')}}
            </el-col>
            <el-col :span="12" class="right">
              {{accountInfo.tradeAccount}}
            </el-col>
          </el-row>
          <el-row class="b-b1  pt-10 pb-10 mb-20">
            <el-col :span="12" class="left">
              {{$t('home.enabled')}}
            </el-col>
            <el-col :span="12" class="right">
              <span v-if="accountInfo.enabled === 'stop'">{{$t('home.enabled_false')}}</span>
              <span v-else-if="accountInfo.enabled === 'open'">{{$t('home.enabled_true')}}</span>
              <span v-else-if="accountInfo.enabled === 'close'">{{$t('home.enabled_close')}}</span>
            </el-col>
          </el-row>
        </div>
      </el-row>
    </el-col>
  </div>
</template>
<script>

export default {
  props: {
    accountInfo: Object
  },
  data () {
    return {
      accountInfoClass: true,
      noBalanceArr: ['IB', 'MF']
    }
  },
  mounted () {
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.page-amount-info{

.account-info {
  height: 420px !important;
}
.box-bod {
  box-sizing: border-box !important;
}
.pt-20 {
  padding-top: 20px;
}
.pb-20 {
  padding-bottom: 20px;
}
.pt-10 {
  padding-top: 10px;
}
.pb-10 {
  padding-bottom: 10px;
}
.p-20 {
  padding: 20px !important;
}
.p-10 {
  padding: 10px;
}
.mt-30 {
  margin-top: 30px;
}
.mt-20 {
  margin-top: 20px;
}
.mb-20 {
  margin-bottom: 20px;
}

.fx {
  display: flex;

}
hr {
  border: 2px solid #eee;
  margin: 20px 0;
}
.el-select {
  width: 100%;
}
.text-orange {
  color: #fec000;
}
.account-info {
  margin-top: 30px;
  padding: 30px;
}
.b-b1 {
  border-bottom: 1px solid #ebebeb;
}
.left {
  font-family: Muli-Regular;
  font-size: 12px;
  color: #666666;
  letter-spacing: 0.13px;
}
.right {
  font-family: Muli-Bold;
  font-size: 16px;
  color: #24282d;
  letter-spacing: 0.14px;
  text-align: right;
}
.account-info-title {
  font-family: Muli-Bold;
  font-size: 18px !important;
  color: #182a54 !important;
  letter-spacing: 0.22px;
  border-bottom: 3px solid #ebebeb;
  padding: 10px 5px 20px;
  span,
  small {
    display: inline-block;
    width: 50%;
  }
  small {
    font-weight: normal;
    font-size: 1rem;
    text-align: right;
  }
}
.money {
  border: 10px solid #eee;
  .balance {
    border-bottom: 6px solid #eee;
  }
  .balance-title {
    font-family: Muli-Bold;
    font-size: 12px;
    color: #666666;
    text-align: center;
  }
  .curBalance {
    font-family: Muli-Bold;
    font-size: 22px;
    color: #24282d;
    letter-spacing: 0.27px;
    text-align: center;
  }
}

.other-info {
  padding: 10px 0;
  border-bottom: 1px solid #eee;
  .label {
    color: #666;
  }
}
.on-account-number{
  text-align: center;
  background: #fff;
  padding-bottom: 200px;
  margin-top: 20px;
  h2{
    padding: 40px 0; font-weight: normal;
  }
  img{
    border: 1px solid #e2e2e2;
    margin:0 20px;
    display: inline-block;
  }
}
@media (max-width: 768px) {
    .layout-container .container .view {
      max-width: 100%;
      padding: 0;
      margin: 0;
    }
    .box-bod {
      margin: 0;
      padding-left: 0;
      padding-right: 0;
    }
    .select-trading-account {
      margin-bottom: 0;
    }
    .m-0{
      margin-left: 0 !important;
      margin-right: 0!important;
    }
    .p-0{
      padding-left: 0!important;
      padding-right: 0!important;
    }
  }
  .yesterday-balance {
    height: 153px !important;
    line-height: 50px !important;
  }
}
</style>
